export const endOf = (date, unit) => {
  const newDate = new Date(date)

  switch (unit) {
    case 'week':
      const day = newDate.getDay()
      // Calcular o dia do sábado sem exceder
      newDate.setDate(newDate.getDate() + (6 - day))
      break
    case 'month':
      // Pattern setDate(1) → setMonth(+1) → setDate(0) evita overflow quando
      // input é o último dia do mês com >28 dias (ex.: Jan 31 sem setDate(1)
      // gera Feb 31 → normaliza para Mar 3 → setDate(0) volta para Feb 28,
      // perdendo um mês inteiro).
      newDate.setDate(1)
      newDate.setMonth(newDate.getMonth() + 1)
      newDate.setDate(0)
      newDate.setHours(23, 59, 59, 999)
      break
    case 'year':
      newDate.setMonth(12)
      newDate.setDate(0)
      break
  }
  return newDate
}
